import script from "./recordVideoContent.vue?vue&type=script&setup=true&lang=js"
export * from "./recordVideoContent.vue?vue&type=script&setup=true&lang=js"

import "./recordVideoContent.vue?vue&type=style&index=0&id=cee9492c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cee9492c"]])

export default __exports__